import classNames from 'classnames';
import React from 'react';

interface EcoFaqTcItemProps {
    /**
     * 内容
     */
    title?: React.ReactNode;
    /**
     * 是否标题
     */
    isHeader?: boolean;
    /**
     * 样式名
     */
    className?: string;
}
export interface EcoFaqTcProps {
    /**
     * 列表
     */
    items: EcoFaqTcItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

const EcoFaqTc: React.FC<EcoFaqTcProps> = ({ className, items = [] }) => {
    const prefixCls = `eco-faq-tc`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                {items?.map((item: EcoFaqTcItemProps, index: number) => {
                    return (
                        <div key={index} className={`${prefixCls}-item${item.isHeader ? ` ${prefixCls}-item-h` : ''}`}>
                            {item.title}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EcoFaqTc;
